<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="6">
        <v-menu
                v-model="menu_mes"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedMes"
                    label="Mês"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="mes" @input="mesAlterado()" locale="pt-br" type="month"></v-date-picker>
              </v-menu>
      </v-col>
      <v-col cols="12" sm="6">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Data</th>
          <th>Horário</th>
          <th>De</th>
          <th>Para</th>
          <th>Valor</th>
          <th>Observações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.time | formatDate }}</td>
          <td>{{ item.time | formatTime }}</td>
          <td>{{ item.userFromName }}</td>
          <td>{{ item.userToName }}</td>
          <td>R$ {{ item.value | formatMoney}}</td>
          <td>{{ item.obs }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    mes: null,
    menu_mes: false
  }),
  created: function() {
    var hoje = new Date();
    this.mes = "" + hoje.getFullYear() + "-" + (hoje.getMonth()+1);
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/credit/from/month/"+this.mes, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.current = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    view: function(id) {
      router.push({ path: `/credit/${id}` });
    },
    register: function (){
      router.push({path: "/credit/0"});
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}/${year}`;
    },
    mesAlterado: function () {
      this.menu_mes = false;
      this.list();
    }
  },
  computed: {
    computedMes() {
      return this.formatDate(this.mes);
    }
  }
};
</script>